import { Debug } from '@svt/debug';

const { error: errorLogger } = Debug('play:searchUtils:error');

const SEARCH_QUERIES = ['SearchPage', 'AutoCompleteSearch'];

export function isSearchQuery(input: RequestInfo, init?: RequestInit) {
    let isSearch = false;
    let body: any = {};

    if (init?.body) {
        try {
            body = JSON.parse(init?.body.toString());
        } catch (e) {
            errorLogger('isSearchQuery failed to parse JSON', e);
        }
    }

    SEARCH_QUERIES.forEach((searchQuery) => {
        if (typeof input === 'string' && input.includes(`operationName=${searchQuery}`)) {
            isSearch = true;
        }

        if (body.operationName === searchQuery) {
            isSearch = true;
        }
    });

    return isSearch;
}
